<template>
  <b-form-group
    label="İçerik"
    label-for="content"
  >
    <validation-provider
      #default="{ errors }"
      name="İçerik"
      rules="required"
    >
      <quill-editor
        v-model="dataItem.content"
        :options="editorOption"
        class="bg-white text-black-50"
      >
        <!--        <div-->
        <!--          id="content_toolbar"-->
        <!--          slot="toolbar"-->
        <!--        >-->
        <!--          <editor-toolbar />-->
        <!--        </div>-->
      </quill-editor>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
// eslint-disable-next-line no-unused-vars
import { required } from '@validations'
// import EditorToolbar from '@/layouts/components/common/EditorToolbar.vue'
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'
// eslint-disable-next-line import/no-extraneous-dependencies
import Quill from 'quill'
import QuillImageUploader from 'quill-image-uploader'
import { quillEditor } from 'vue-quill-editor'
import axiosIns from '@/libs/axios'

Quill.register('modules/imageUploader', QuillImageUploader)

export default {
  name: 'Content',
  components: {
    BFormGroup,
    quillEditor,
    ValidationProvider,
    // EditorToolbar,
  },
  data() {
    return {
      required,
      file: null,
      editorOption: {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ header: 1 }, { header: 2 }],
              [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
              ['link', 'image', 'video'],
            ],
            handlers: {
              image: this.imageHandler,
            },
          },
          imageUploader: {
            upload: file => this.uploadFile(file, 'image'),
          },
        },
        theme: 'snow',
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['blog/dataItem']
    },
  },
  created() {
    localize('tr')
  },
  methods: {
    uploadFile(file, type) {
      const formData = new FormData()
      formData.append('upload_file', file)
      formData.append('type', type) // Opsiyonel, sunucunuza göre düzenleyin

      return axiosIns
        .post('/Admin/core/file_upload/editorUpload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(response =>
        // Sunucudan gelen dosya URL'sini döndürüyoruz.
          response.data.url)
        .catch(error => {
          console.error('Dosya yükleme hatası:', error)
          return ''
        })
    },
    imageHandler() {
      const input = document.createElement('input')
      input.setAttribute('type', 'file')
      input.setAttribute('accept', 'image/*')
      input.click()

      input.onchange = async () => {
        const file = input.files[0]
        const url = await this.uploadFile(file, 'image')
        const range = this.quill.getSelection()
        this.quill.insertEmbed(range.index, 'image', url)
      }
    },
  },
}
</script>
